import { Component, OnInit } from '@angular/core';
import { RudderStack } from '../../services/rudderstack';
import { ProfileService } from '../services/profile.service';

@Component({
	selector: 'app-app',
	templateUrl: './app.page.html',
	styleUrls: ['./app.page.scss'],
})
export class AppPage implements OnInit {
	constructor(
		private rudderStack: RudderStack,
		private profileService: ProfileService,
	) {
		//
		this.profileService.loadProfileInit();
		this.profileService.loadProfileAPI().subscribe();
	}

	reloadURL() {
		//
	}
	ngOnInit() {
		//
	}

	logout() {
		//
	}
}
